import { render } from "./DonorQuestionnaireInformation.vue?vue&type=template&id=20e4828c"
import script from "./DonorQuestionnaireInformation.vue?vue&type=script&lang=js"
export * from "./DonorQuestionnaireInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__